import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card } from '@/components/ui/card';
import { toast } from 'sonner';

export const SetupPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const { setupPassword } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) return toast.error('Invalid invitation link');
    if (password.length < 8) return toast.error('Password must be at least 8 characters');
    if (password !== confirm) return toast.error('Passwords do not match');
    
    setLoading(true);
    const result = await setupPassword(token, password);
    setLoading(false);
    
    if (result.success) {
      toast.success('Password set successfully');
      navigate('/', { replace: true });
    } else {
      toast.error(result.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#F8FAFC' }}>
      <Card className="w-full max-w-md p-8">
        <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: 'Manrope', color: '#1E3A8A' }}>OctoBoots</h1>
        <p className="text-slate-600 mb-6">Set up your password</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label>New Password</Label>
            <Input data-testid="setup-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} />
          </div>
          <div>
            <Label>Confirm Password</Label>
            <Input data-testid="setup-confirm-input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
          </div>
          <Button data-testid="setup-submit-btn" type="submit" disabled={loading} className="w-full" style={{ backgroundColor: '#1E3A8A' }}>
            {loading ? 'Setting up...' : 'Set Password'}
          </Button>
        </form>
      </Card>
    </div>
  );
};
